import { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LanguageContext } from '../../contexts/LanguageProvider';
import { API_ENDPOINTS } from '../../configs/apiConfig';
import translations from "./translations";

function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { language } = useContext(LanguageContext);
  const userData = {
    username: '',
    name: '',
    email: '',
    role: '',
    subtype: '',
    cpf: '',
    dateBirth: '',
    state: '',
    city: '',
    company: '',
    educationalInstitution: '',
    areaplanted: '',
    plantingChallengesDescription: '',
    cropType: '',
    isInvolvedWithBiological: null,
    isFarmerChild: null,
    conductsCoffeeResearch: null,
    permissionToCollectGeographicData: null,
    platformInterest: '',
    otherDescription: '',
    password: '',
    replacePassword: '',
  };
  

  const t = translations[language] || translations.pt;

  useEffect(() => {
    if (!token) {
      setMessage(t.errorInvalidToken);
    }
  }, [token, t]);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    
    if (!token) {
      setMessage(t.errorInvalidToken);
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage(t.errorPasswordMismatch);
      return;
    }

    if (newPassword.length < 6) {
      setMessage(t.errorPasswordTooShort);
      return;
    }

    setIsLoading(true);
    try {

      console.log('Resetting password for token:', token);
      console.log('User data:', { ...userData, password: token, replacePassword: newPassword });
      await axios.put(
        API_ENDPOINTS.USERS_PASSWORD_RESET("token"),
        { ...userData, password: token, replacePassword: newPassword },
      );

      setMessage(t.successPasswordReset);
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (error) {
      if (error.response?.status === 400) {
        setMessage(t.errorInvalidToken);
      } else if (error.response?.status === 404) {
        setMessage(t.errorTokenExpired);
      } else {
        setMessage(t.errorServer);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container text-center">
      <h2 className="mb-4">{t.resetPasswordTitle}</h2>
      {/* {token ? (
        <p>
          {token}
        </p>
      ) : (
        <p className="text-danger">{t.errorInvalidToken}</p>
      )} */}

      <form onSubmit={handleResetPassword}>
        <div className="mb-4">
          <label className="form-label text-start">
            <strong>{t.newPassword}</strong>
            <br />
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder={t.newPassword}
              className="form-control"
              disabled={!token || isLoading}
              required
            />
          </label>
        </div>
        
        <div className="mb-4">
          <label className="form-label text-start">
            <strong>{t.confirmPassword}</strong>
            <br />
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder={t.confirmPassword}
              className="form-control"
              disabled={!token || isLoading}
              required
            />
          </label>
        </div>
        
        <button 
          type="submit" 
          className="btn btn-primary"
          disabled={!token || isLoading}
        >
          {isLoading ? t.loading : t.resetPasswordButton}
        </button>
      </form>

      {message && (
        <p className={`mt-3 p-2 border rounded ${
          message === t.successPasswordReset 
            ? 'text-success border-success' 
            : 'text-danger border-danger'
        }`}>
          {message}
        </p>
      )}
    </div>
  );
}

export default ResetPassword;